/**
 * Created by Damian on 2017-11-03.
 */


export function fixHex(val){

  if ( val.length < 3 ) val = '000';
  if ( parseInt(val,16) > parseInt('ffffff',16) ) val ='ffffff';
  if ( isNaN(parseInt( val,16)) ) val ='ffffff';

  return val;
}

export function fix255(val){

  if ( isNaN(val) ) return 0;
  if ( val > 255) return 255;
  if ( val < 0 ) return 0;
  return val;
}

export function hexToRGB(hex){
  if ( hex == undefined ) return null;
  hex = hex.toString().replace('#','');
  var r = parseInt(hex.substring(0, hex.length/3), 16);
  var g = parseInt(hex.substring(hex.length/3, 2*hex.length/3), 16);
  var b = parseInt(hex.substring(2*hex.length/3, 3*hex.length/3), 16);

  var result = {
    r: r,
    g: g,
    b: b
  }

  return result;
}

export function HEXtoCMYK(hex){
  return RGBtoCMYK(hexToRGB(hex));
}

export function RGBtoCMYK(rgb){

  var result = new _CMYK(0,0,0,0);

  var r = rgb.r / 255;
  var g = rgb.g / 255;
  var b = rgb.b / 255;

  result.k = Math.min( 1 - r, 1 - g, 1 - b );


  // result.k = 1 - Math.max(r,g,b);

  result.c = ( 1 - r - result.k ) / ( 1 - result.k );
  result.m = ( 1 - g - result.k ) / ( 1 - result.k );
  result.y = ( 1 - b - result.k ) / ( 1 - result.k );

  if ( isNaN(result.c)) result.c = 0;
  if ( isNaN(result.m)) result.m = 0;
  if ( isNaN(result.y)) result.y = 0;

  result.c = Math.round( result.c * 100 );
  result.m = Math.round( result.m * 100 );
  result.y = Math.round( result.y * 100 );
  result.k = Math.round( result.k * 100 );

  return result;
}

export function CMYKtoRGB(CMYK){


  var result = new _RGB(0, 0, 0);

  var c = CMYK.c / 100;
  var m = CMYK.m / 100;
  var y = CMYK.y / 100;
  var k = CMYK.k / 100;

  result.r = 255 * (1-c) * (1-k);
  result.g = 255 * (1-m) * (1-k);
  result.b = 255 * (1-y) * (1-k);

  return result;
}

export function _CMYK (c, m, y, k) {
  if (c <= 0) { c = 0; }
  if (m <= 0) { m = 0; }
  if (y <= 0) { y = 0; }
  if (k <= 0) { k = 0; }

  if (c > 100) { c = 100; }
  if (m > 100) { m = 100; }
  if (y > 100) { y = 100; }
  if (k > 100) { k = 100; }

  this.c = c;
  this.m = m;
  this.y = y;
  this.k = k;
}

export function _RGB(r, g, b) {
  if (r <= 0) { r = 0; }
  if (g <= 0) { g = 0; }
  if (b <= 0) { b = 0; }

  if (r > 255) { r = 255; }
  if (g > 255) { g = 255; }
  if (b > 255) { b = 255; }

  this.r = r;
  this.g = g;
  this.b = b;
}

export function _RGBFix(rgb) {

  let r = rgb.r;
  let g = rgb.g;
  let b = rgb.b;

  if (rgb.r <= 0) { r = 0; }
  if (rgb.g <= 0) { g = 0; }
  if (rgb.b <= 0) { b = 0; }

  if (isNaN(rgb.r)) { r = 0; }
  if (isNaN(rgb.g)) { g = 0; }
  if (isNaN(rgb.b)) { b = 0; }

  if (rgb.r > 255) { r = 255; }
  if (rgb.g > 255) { g = 255; }
  if (rgb.b > 255) { b = 255; }

  let obj = {
    r : r,
    g : g,
    b : b
  }

  return obj;
}


export function rgbToHex(rgb) {

  return ((rgb.b | rgb.g << 8 | rgb.r << 16) | 1 << 24).toString(16).slice(1);

}